import React, { useState, useEffect } from "react";
import '../servicecalendar.css';

const checkBoxStyle = {
    border: '1px solid grey',
    width: '12px'
};

const checkBoxLabelStyle = {
    fontSize: '13px',
    marginLeft: '4px'
};

const selectStyle = {
    width: '100%',
    padding: '2px 4px 3px',
    color: 'black',
    fontSize: '12px !important'
};

const selectDownStyle = {
    width: '100%',
    marginTop: '10px',
    padding: '2px 4px 3px',
    color: 'black',
    fontSize: '12px !important'
};

export const ServiceCalendarPopupFilter = ({
    displayStyle,
    date,
    vehicle,
    left,
    top
}) => {
    const [checkedSchedule, setCheckedSchedule] = useState(true);
    const [uncheckedSchedule, setUncheckedSchedule] = useState(true);
    const [completedSchedule, setCompletedSchedule] = useState(true);
    const [notcompletedSchedule, setNotcompletedSchedule] = useState(true);
    const [approvedSchedule, setApprovedSchedule] = useState(true);
    const [notapprovedSchedule, setNotapprovedSchedule] = useState(true);

    const [selectedVechicle, setSelectedVehicle] = useState("");
    const [selectedServiceType, setSelectedServiceType] = useState("");
    const [selectedMake, setSelectedMake] = useState("");
    const [selectedModel, setSelectedModel] = useState("");
    const [selectedStatuary, setSelectedStatuary] = useState("");
    const [selectedSupplier, setSelectedSupplier] = useState("");

    return (
        <div
            style={{
                width: '30em',
                display: displayStyle,
                left: left,
                top: top,
                position: "absolute",
                background: "white", 
                border: "1px solid lightgrey",
                boxShadow: '5px 4px 4px rgba(10, 10, 10, 0.4)',
                zIndex: "1000"
            }}
        >
            <div style={{ width: '100%', height: '10px', background: 'rgba(36, 119, 168, 1)' }}></div>
            <div style={{ width: '100%', padding: '10px 15px 10px' }}>
                <div style={{ fontWeight: 'bolder', paddingLeft: '6px', fontSize: '15px' }}>
                    Search Filter
                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ width: '30%', marginTop: '15px' }}>
                        <div style={{ display: 'flex' }}>
                            <input 
                                type="checkbox" value={checkedSchedule} checked={checkedSchedule ? 'checked': ''}
                                style={checkBoxStyle}
                                onChange={() => setCheckedSchedule(!checkedSchedule)}
                            />
                            <label style={checkBoxLabelStyle}>Schedule</label>
                        </div>
                        <div style={{  display: 'flex', marginTop: '8px'}}>
                            <input 
                                type="checkbox" value={uncheckedSchedule} checked={uncheckedSchedule ? 'checked': ''}
                                style={checkBoxStyle}
                                onChange={() => setUncheckedSchedule(!uncheckedSchedule)}
                            />
                            <label style={checkBoxLabelStyle}>Unschedule</label>
                        </div>
                    </div>
                    <div style={{ width: '30%', marginTop: '15px' }}>
                        <div style={{ display: 'flex' }}>
                            <input 
                                type="checkbox" value={completedSchedule} checked={completedSchedule ? 'checked': ''}
                                style={checkBoxStyle}
                                onChange={() => setCompletedSchedule(!completedSchedule)}
                            />
                            <label style={checkBoxLabelStyle}>Completed</label>
                        </div>
                        <div style={{  display: 'flex', marginTop: '8px'}}>
                            <input 
                                type="checkbox" value={notcompletedSchedule} checked={notcompletedSchedule ? 'checked': ''}
                                style={checkBoxStyle}
                                onChange={() => setNotcompletedSchedule(!notcompletedSchedule)}
                            />
                            <label style={checkBoxLabelStyle}>Not Completed</label>
                        </div>
                    </div>
                    <div style={{ width: '30%', marginTop: '15px' }}>
                        <div style={{ display: 'flex' }}>
                            <input 
                                type="checkbox" value={approvedSchedule} checked={approvedSchedule ? 'checked': ''}
                                style={checkBoxStyle}
                                onChange={() => setApprovedSchedule(!approvedSchedule)}
                            />
                            <label style={checkBoxLabelStyle}>Approved</label>
                        </div>
                        <div style={{  display: 'flex', marginTop: '8px'}}>
                            <input 
                                type="checkbox" value={notapprovedSchedule} checked={notapprovedSchedule ? 'checked': ''}
                                style={checkBoxStyle}
                                onChange={() => setNotapprovedSchedule(!notapprovedSchedule)}
                            />
                            <label style={checkBoxLabelStyle}>Not Approved</label>
                        </div>
                    </div>
                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ width: '30%', marginTop: '15px' }}>
                        <select value={selectedVechicle} onChange={(e) => {setSelectedVehicle(e.target.value)}} style={selectStyle}>
                            <option value="">All Vechicles</option>
                            <option value="FE22FF">FE22FF</option>
                        </select>
                        <select value={selectedServiceType} onChange={(e) => {setSelectedServiceType(e.target.value)}} style={selectDownStyle}>
                            <option value="">All Service Types</option>
                            <option value="aaa">ServiceType1</option>
                        </select>
                    </div>
                    <div style={{ width: '30%', marginTop: '15px' }}>
                        <select value={selectedMake} onChange={(e) => {setSelectedMake(e.target.value)}} style={selectStyle}>
                            <option value="">All Makes</option>
                            <option value="Make1">Make1</option>
                        </select>
                        <select value={selectedModel} onChange={(e) => {setSelectedModel(e.target.value)}} style={selectDownStyle}>
                            <option value="">All Models</option>
                            <option value="Model1">Model1</option>
                        </select>
                    </div>
                    <div style={{ width: '30%', marginTop: '15px' }}>
                        <select value={selectedStatuary} onChange={(e) => {setSelectedStatuary(e.target.value)}} style={selectStyle}>
                            <option value="">All Statuary</option>
                            <option value="Statuary1">Statuary1</option>
                        </select>
                        <select value={selectedSupplier} onChange={(e) => {setSelectedSupplier(e.target.value)}} style={selectDownStyle}>
                            <option value="">All Suppliers</option>
                            <option value="Supplier1">Supplier1</option>
                        </select>
                    </div>
                </div>
                <div>
                    <button className="btn-filter-in-popup" style={{ width: '75px' }}>OK</button>
                    <button className="btn-filter-in-popup" style={{ width: '65px', background: 'rgb(127, 127, 127)', marginLeft: '3%' }}>Cancel</button>
                    <button className="btn-filter-in-popup" style={{ width: '65px', background: 'rgb(127, 127, 127)', float: 'right'  }}>Reset</button>
                </div>
            </div>
        </div>
    );
};
